// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "Your classic polling widget, allowing readers to be heard and journalists to hear them.";
const CONFIG: InteractivesMenuItemConfig = {
  cradleIframeUrlRoot:"https://www.theage.com.au/interactive/2019/reader-poll/?resizable=true",
  // cradleIframeUrlRoot:"https://www.smh.com.au/interactive/tests/reader-poll/?resizable=true",
  name: "Reader poll",
  id: "reader-poll",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Data viz", "Configurable", "Recorded input"],
  description,
  image: DisplayImage,
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ReaderPollConfigTool" */ "app/components/tools/ReaderPollConfigTool/ReaderPollConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ReaderPollConfigTool"]
  })
};

export default CONFIG;
